import { Gateway } from "./BaseUrl";



export async function Login(username, password) {
    try {
        let response = await fetch(Gateway + '/token', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                UserName: username,
                Password: password
            })
        });
        
        if (!response.ok) {
            if (response.status != 503 && response.status != 403) {
                throw await response.json();
            }
        }

        return await respond(response, "json");
    }
    catch(e){
        console.error("Error logging in: " + e);
        throw e;
    };
}

export async function Get(path, returnType = "json", callback = () => { }) {
    try {
        let token = sessionStorage.getItem("tkn");
        const response = await fetch(path, {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + token
            }
        });

        if (!response.ok) {
            if (response.status == 401) {
                callback();
            } else {
                throw await response.json();
            }
        }

        return await respond(response, returnType);    
    } catch (e) {
        console.log("GET Error - path", path);
        console.log("GET Error", e);
        throw e;
    }
}

export async function Post(path, body, returnType = "json", callback = () => { }) {
    try {
        let token = sessionStorage.getItem("tkn");
        const response = await fetch(path, {
            method: "POST",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json" 
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            if (response.status == 401) {
                callback();
            } else {
                throw await response.json();
            }
        }

        return await respond(response, returnType);
    } catch (e) {
        console.log("POST Error - path", path);
        console.log("POST Error", e);
        throw e;
    }
}

export async function Put(path, body, returnType = "json", callback = () => { }) {
    try {
        let token = sessionStorage.getItem("tkn");
        const response = await fetch(path, {
            method: "PUT",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json" 
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            if (response.status == 401) {
                callback();
            } else {
                throw await response.json();
            }
        }

        return await respond(response, returnType);
    } catch (e) {
        console.log("PUT Error - path", path);
        console.log("PUT Error", e);
        throw e;
    }
}

export async function Delete(path, body, returnType = "json", callback = () => { }) {
    try {
        let token = sessionStorage.getItem("tkn");
        const response = await fetch(path, {
            method: "DELETE",
            headers: {
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            if (response.status == 401) {
                callback();
            } else {
                throw await response.json();
            }
        }

        return await respond(response, returnType);
    } catch (e) {
        console.log("DELETE Error - path", path);
        console.log("DELETE Error", e);
        throw e;
    }
}

async function respond(response, returnType) {
    switch (returnType.toLowerCase()) {
        case "json":
            return await response.json();
        case "text":
            return await response.text();
        case "html":
            return await response.html();
        case "script":
            return await response.script();
        case "xml":
            return await response.xml();
        default:
            return await response.json();
    }
}


// WEBPACK FOOTER //
// ./src/Ajax.js